module.exports = __webpack_public_path__ + "static/media/trace-it axis.98c95c57.webp";